import { queryProjects } from '@/features/projects/data';
import type { ProjectDto, QueryResult } from '@flowqa/shared';

export const fetchProjectsGrid = async (
  orgId?: string | null,
): Promise<QueryResult<ProjectDto>> => {
  const result = await queryProjects(orgId ?? undefined);
  if (orgId === null) {
    const items = result.items.filter((proj) => !proj.organisationId);
    return { ...result, items, total: items.length };
  }
  return result;
};
